export const RECENT_APPLICATIONS_YEAR_FILTER = 5;
export const CARD_NAME = "Recent applications";
